import { render, staticRenderFns } from "./TabPP3.vue?vue&type=template&id=5e15aa03&scoped=true"
import script from "./TabPP3.vue?vue&type=script&lang=js"
export * from "./TabPP3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e15aa03",
  null
  
)

export default component.exports